import { Button } from "@tql/ui-components-react/tql/buttons";
import { plusCircleLine } from "@tql/ui-components-react/untitled/icons";

import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { TraxGrid } from "~/shared/components/trax-grid/trax-grid.tsx";
import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";
import type { RoutingGuideType } from "~/shared/schemas/routing-guide-schema.ts";

import { useGetRoutingGuideEnums } from "../../hooks/use-get-routing-guide-enums.ts";
import { AutoSelectSection } from "./components/auto-select-section/index.tsx";
import { NameField } from "./components/name-field/index.tsx";
import { useRoutingGuideModal } from "./hooks/use-routing-guide-modal.ts";

export const RoutingGuideModal = ({
	onClose,
	routingGuide,
}: {
	onClose: () => void;
	routingGuide: RoutingGuideType | null;
}) => {
	const {
		name,
		setName,
		clearNameError,
		rules,
		carriers,
		isAutoSelectActive,
		setIsAutoSelectActive,
		selectedAutoSelectOption,
		setSelectedAutoSelectOption,
		ruleColumns,
		carrierColumns,
		handleClose,
		handleSave,
		addRule,
		addCarrier,
		onRuleChange,
		onCarrierChange,
		showNameError,
	} = useRoutingGuideModal({ onClose, routingGuide });

	const { routingGuideEnumsIsLoading, routingGuideEnumsIsFetching } =
		useGetRoutingGuideEnums();

	return (
		<TraxModal
			onClose={handleClose}
			title={"Routing Guide Rule Builder"}
			width={"98%"}
		>
			{routingGuideEnumsIsLoading || routingGuideEnumsIsFetching ? (
				<LoadingSpinner />
			) : (
				<>
					{" "}
					<div>Quote/Shipment Details</div>
					<NameField
						initialValue={name}
						onClearError={clearNameError}
						onCommit={setName}
						showError={showNameError}
					/>
					<TraxGrid
						columns={ruleColumns}
						data={rules}
						dataItemKey={"id"}
						editable={false}
						navigatable={false}
						onItemChange={onRuleChange}
					/>
					<div style={{ marginTop: "10px" }}>
						<Button
							data-testid={"routing-guide-add-condition-button"}
							onClick={addRule}
							svgIcon={plusCircleLine}
							variant={"primary"}
						>
							Add New Condition
						</Button>
					</div>
					<hr />
					<div>Carrier/Service Levels</div>
					<TraxGrid
						columns={carrierColumns}
						data={carriers}
						dataItemKey={"id"}
						editable={false}
						navigatable={false}
						onItemChange={onCarrierChange}
					/>
					<div style={{ marginTop: "10px" }}>
						<Button
							data-testid={"routing-guide-add-carrier-button"}
							onClick={addCarrier}
							svgIcon={plusCircleLine}
							variant={"primary"}
						>
							Add New Condition
						</Button>
					</div>
					<hr />
					<AutoSelectSection
						carriers={carriers}
						isActive={isAutoSelectActive}
						method={selectedAutoSelectOption}
						onMethodChange={setSelectedAutoSelectOption}
						onToggle={setIsAutoSelectActive}
					/>
					<div
						style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
					>
						<Button onClick={handleClose} variant={"secondary"}>
							Cancel
						</Button>
						<Button onClick={() => handleSave(false)} variant={"primary"}>
							Save and Deactivate
						</Button>
						<Button onClick={() => handleSave(true)} variant={"primary"}>
							Save and Activate
						</Button>
					</div>{" "}
				</>
			)}
		</TraxModal>
	);
};
